import { render } from "./LanguageChange.vue?vue&type=template&id=6eb2ed8f&scoped=true"
import script from "./LanguageChange.vue?vue&type=script&lang=js"
export * from "./LanguageChange.vue?vue&type=script&lang=js"

import "./LanguageChange.vue?vue&type=style&index=0&id=6eb2ed8f&lang=css"
import "./LanguageChange.vue?vue&type=style&index=1&id=6eb2ed8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb2ed8f"],['__file',"src/components/LanguageChange/LanguageChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb2ed8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb2ed8f', __exports__)) {
    api.reload('6eb2ed8f', __exports__)
  }
  
  module.hot.accept("./LanguageChange.vue?vue&type=template&id=6eb2ed8f&scoped=true", () => {
    api.rerender('6eb2ed8f', render)
  })

}


export default __exports__